import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import Footer from './Footer'
import _ from 'lodash'

export default class ReviewsPage extends BaseComponent {

  constructor(props) {
  	super(props)
    this.perPage = 3
  }

  render() {
    const reviewsPage = _.filter(this.props.data.pages, { template: "reviews" })[0]

  	let page = this.props.match.params.page || 1
    page <= 0 ? page = 1 : page = this.props.match.params.page

    let selectedReviews = _.drop(this.props.data.reviews, (page-1)*this.perPage).slice(0, this.perPage)

    let reviews = selectedReviews.map((item, i) => {
      return (
        <li key={ i }>
          <div className="image">
            <img src={ item.logo ? item.logo : "/assets/img/user-icon.png" } alt={ item.title + " logo" }/>
          </div>
          <div className="text">
            <h4>{ item.title }</h4>
            <p>{ item.description }</p>
          </div>
          { item.url !== "" ? <NavLink className="more" to={ item.url }>Zobacz <span>realizacje</span></NavLink> : null }
        </li>
      )
    })

    let pages = Math.ceil(this.props.data.reviews.length / this.perPage)

    let pagination = []

    for (var i = 0; i < pages; i++) {
      let cl = ""
      if (page === (i+1)) {
        cl = "active"
      }
      let item = (
        <li key={ i } className={ cl }><NavLink to={ "/opinie/" + (i+1) }>{ i+1 }</NavLink></li>
      )
     pagination.push(item)
    }

    return (
      <section className="reviews">
      	<ul className="breadcrumbs">
      		<div className="container-big">
	      		<li><NavLink to="/">Strona główna</NavLink></li>
	      		<li><NavLink to="/opinie">Opinie</NavLink></li>
      		</div>
      		<div className="bottom"></div>
      	</ul>
      	<div className="container">
      		<h1 dangerouslySetInnerHTML={{ __html: this.addColor(reviewsPage.additional_fields.pageTitle) }}></h1>
      		<p className="sub" dangerouslySetInnerHTML={{ __html: reviewsPage.additional_fields.content }}></p>
      	</div>
  		<div className="reviews-inner">
  			<ul className="reviews-list">
	  		  <div className="container">
	            { reviews }
              </div>
            </ul>
            { this.props.data.reviews.length > 2 ? <div className="pagination-holder"><ul className="pagination">
              { pagination }
            </ul></div> : null }
  		</div>
      	<Footer data={ this.props.data } settings={ this.props.data.settings }/>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/ReviewsPage.js